import React, { PropTypes, Component } from 'react'
import { connect } from 'react-redux'
import Link from 'react-router/lib/Link'
import { Row, Field } from 'react-gridforms'
import Panel from 'react-bootstrap/lib/Panel'
import ListGroup from 'react-bootstrap/lib/ListGroup'
import Icon from 'react-icons/lib/md/search'
import trim from 'validator/lib/trim'

import { searchPaymentScheme } from './actions'

class Search extends Component {

  _onSearch = (e) => {
    e.preventDefault()

    const value = trim(this._input.value)

    if (value === '') {
      return
    }

    this.props.dispatch(searchPaymentScheme(value))
  }

  _renderSearch() {
    return (
      <form className="grid-form" onSubmit={this._onSearch}>
        <Row>
          <Field className="field--btn-inline">
            <label htmlFor="quicksearch">Search</label>
            <input type="text" ref={(c) => this._input = c} placeholder="Search PS Code" autoFocus />
            <button type="submit" className="btn-icon btn-inline"><Icon /></button>
          </Field>
        </Row>
      </form>
    )
  }

  _renderList() {
    const { list } = this.props

    return (
      <div>
        {list.map((item) => (
          <Link
            key={item.get('id')}
            to={`/manage/payment-schemes/${item.get('id')}`}
            className="list-group-item"
            activeClassName="active"
          >
            <div><strong>{item.get('code')}</strong></div>
            <small>{item.get('name')}</small>
          </Link>
        ))}
      </div>
    )
  }

  render() {
    const { onPSForm } = this.props

    const header = (
      <div className="row">
        <div className="col-xs-8">Payment Schemes</div>
        <div className="col-xs-4 text-right">
          <button type="button" onClick={onPSForm} className="btn-icon btn-inline">+</button>
        </div>
      </div>
    )

    return (
      <Panel header={header}>
        {this._renderSearch()}
        <ListGroup fill>
          {this._renderList()}
        </ListGroup>
      </Panel>
    )
  }
}

Search.propTypes = {
  list: PropTypes.object,
  onPSForm: PropTypes.func,
  dispatch: PropTypes.func,
}

export default connect()(Search)



// WEBPACK FOOTER //
// ./src/containers/Manage/PaymentSchemes/search.js